// Utility for retrieving the effective auth token from localStorage with fallbacks
// Usage: import { getEffectiveToken } from '../utils/tokenUtils';
// const token = getEffectiveToken(true);

export const getEffectiveToken = (debug = false) => {
  try {
    let token =
      localStorage.getItem('authToken') ||
      localStorage.getItem('auth_token') ||
      localStorage.getItem('jwt_token') ||
      localStorage.getItem('token');

    // Try to augment with authInfo.token if present
    try {
      const authInfoRaw = localStorage.getItem('authInfo');
      const authInfo = authInfoRaw ? JSON.parse(authInfoRaw) : null;

      if (authInfo && authInfo.token) {
        token = authInfo.token;
      }
    } catch (e) {
      if (debug) console.warn('Could not parse authInfo from localStorage:', e);
    }
    return token || null;
  } catch (e) {
    if (debug) console.error('Error while retrieving effective token:', e);
    return null;
  }
};

export default { getEffectiveToken };
